import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["connectDropTarget"];
import { forwardRef } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { DropTarget } from 'react-dnd';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import ResizableEditorPreview from './ResizableEditorPreview';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadViewColumnWrapper = styled(UIFlex).withConfig({
  displayName: "ResizableThreadViewWrapper__ThreadViewColumnWrapper",
  componentId: "ixgklf-0"
})(["align-items:stretch;flex-direction:column;height:100%;overflow:auto;"]);
const TWENTY_PERCENT_OF_WINDOW = window.innerHeight * 0.2;
const MIN_HEIGHT_OF_EDITOR_COMPONENTS = 250;
// the minimum height should be the larger between 20% of screen height or the minimum required space for the editor components
export const minEditorHeight = Math.max(TWENTY_PERCENT_OF_WINDOW, MIN_HEIGHT_OF_EDITOR_COMPONENTS);

// max is 75% of the approximate height of the window height
export const getMaxEditorHeight = () => window.innerHeight * 0.75;
export const DRAG_TYPE = 'thread-view-resize';
export const RESIZABLE_REPLY_EDITOR_ID = 'RESIZABLE_REPLY_EDITOR_ID';
const dropTargetConfig = {
  drop: (__props, monitor) => {
    const item = monitor.getItem();
    const delta = monitor.getDifferenceFromInitialOffset().y;
    const newHeightWithinBounds = Math.min(getMaxEditorHeight(), Math.max(minEditorHeight, Math.round(item.height - delta)));
    item.setHeight(newHeightWithinBounds);
  }
};
const collect = connectDrop => ({
  connectDropTarget: connectDrop.dropTarget()
});
const ResizableThreadViewColumn = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      connectDropTarget
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return connectDropTarget(
  /*#__PURE__*/
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'ForwardedRef<unknown>' is not assignable to ... Remove this comment to see the full error message
  _jsxs("div", {
    className: "height-100",
    ref: ref,
    style: {
      position: 'relative'
    },
    children: [/*#__PURE__*/_jsx(ThreadViewColumnWrapper, Object.assign({}, rest)), /*#__PURE__*/_jsx(ResizableEditorPreview, Object.assign({}, rest, {
      maxEditorHeight: getMaxEditorHeight(),
      minEditorHeight
    }))]
  }));
});
ResizableThreadViewColumn.displayName = 'ResizableThreadViewColumn';
const DropColumn = DropTarget(DRAG_TYPE, dropTargetConfig, collect)(ResizableThreadViewColumn);
export default SharedDragDropContext()(DropColumn);